<ion-item (click)="onSelect()">
  <ion-avatar slot="start" [ngClass]="{ new: isNew }">
    <ion-icon [icon]="stampIcon"></ion-icon>
  </ion-avatar>

  <ion-label class="ion-text-nowrap">
    <h3 class="ellipses">
      <strong>
        {{ item.CreatedUTC | sagaDate: 'JournalDateFormat' }}&nbsp;&nbsp;<span>{{ stampName | translate }}</span>
      </strong>
    </h3>
    <h3 *ngIf="showUserName">{{ item.UserName }}</h3>
    <p [ngClass]="{ expanded: isExpanded }">{{ stampText | translateKeys }}</p>
  </ion-label>

  <ion-button *ngIf="toolIcon" (click)="onToolClicked($event)" slot="end" expand="round" fill="clear">
    <ion-icon slot="icon-only" [name]="toolIcon"></ion-icon>
  </ion-button>
</ion-item>
